export const CANVAS_TOP_LEFT_PADDING_GRID_UNITS = 5;
